import { useCallback, useMemo } from 'react';

import { usePublicationSettings } from 'hooks/publication-settings';
import { formatInTimeZone } from 'utils/dates';

const TIMESTAMP_FORMAT = 'MM/dd/yyyy hh:mm aa';
const ET_TIMEZONE = { timezone: 'America/New_York', timezoneAbbreviation: 'ET' } as const;

export const useTimestampFormatters = () => {
  const { data: publicationSettings } = usePublicationSettings();

  const isETTimestamp = useMemo(() => {
    if (!publicationSettings) return false;
    return publicationSettings.publicationSetting.preferredTimezone.timezone === ET_TIMEZONE.timezone;
  }, [publicationSettings]);

  const formatTimestamp = useCallback(
    (timestamp: string | number | Date) =>
      formatInTimeZone(timestamp, publicationSettings?.publicationSetting.preferredTimezone, TIMESTAMP_FORMAT, {
        showTimezoneAbbreviation: true
      }),
    [publicationSettings?.publicationSetting.preferredTimezone]
  );

  const formatTimestampET = useCallback(
    (timestamp: string | number | Date) =>
      formatInTimeZone(timestamp, ET_TIMEZONE, TIMESTAMP_FORMAT, {
        showTimezoneAbbreviation: true
      }),
    []
  );

  return { isETTimestamp, formatTimestamp, formatTimestampET };
};
